var $99adce32ecba6a6a$exports = {};
$99adce32ecba6a6a$exports = {
    "help": `\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}`,
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`
};


export {$99adce32ecba6a6a$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
